import { useIntl } from 'react-intl';

import { LinkButton } from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import Link from '@atlaskit/link';
import { xcss, Box, Stack, Text } from '@atlaskit/primitives';

import packageFreeSvg from 'src/components/packages/components/packages-empty-states/assets/packages-unavailable-free.svg';
import {
  DOCS_TESTING,
  PLAN_AND_BILLING_URL,
} from 'src/components/pipelines/constants';

import { messages } from '../messages';

const imageXcss = xcss({
  width: '200px',
  height: '200px',
});

const learnMoreLinkXcss = xcss({
  alignContent: 'center',
  paddingInlineStart: 'space.100',
});

export const TestManagementUnavailable = () => {
  const { formatMessage } = useIntl();

  return (
    <EmptyState
      header={formatMessage(messages.paidPlanRequiredHeader)}
      renderImage={() => (
        <Box xcss={imageXcss} as="img" src={packageFreeSvg} alt="" />
      )}
      description={
        <Stack space="space.150">
          <Text as="p">
            {formatMessage(messages.paidPlanRequiredDescription)}
          </Text>
        </Stack>
      }
      primaryAction={
        <LinkButton appearance="primary" href={PLAN_AND_BILLING_URL}>
          {formatMessage(messages.explorePlans)}
        </LinkButton>
      }
      tertiaryAction={
        <Box xcss={learnMoreLinkXcss}>
          <Link href={DOCS_TESTING} target="_blank" rel="noopener noreferrer">
            {formatMessage(messages.learnAboutTestManagement)}
          </Link>
        </Box>
      }
    />
  );
};
